import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";
import {UserType} from "services/enums/userType.enum";

export class UserModel extends Model implements IModel<UserModel> {
  public email: string = "";
  public name: string = "";
  public password: string = "";
  public confirmPassword: string = "";
	public userType: string = "";
  public organizationId: string | null = null;

	public get userTypeData() {
		return UserType.getBy(this.userType);
	}

  static create(input: any): UserModel {
    return ObjectMapper.deserialize<UserModel>(UserModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
